import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomFieldsIndex } from '@/types/serializers';

export default function useFetchCandidateProfileCustomFields() {
  return useQuery({
    queryKey: ['candidate_profile_custom_fields'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profiles/custom_fields.json');
      if (!response.ok) {
        throw new Error('カスタム項目の取得に失敗しました');
      }
      const data: AgentApiCustomFieldsIndex = await response.json();
      return data;
    },
  });
}
